var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-contact-block-row",class:[{ noRow: _vm.noRow }]},[_c('div',{staticClass:"subtitle label"},[_vm._v(_vm._s(_vm.$attrs.name))]),_c('div',{staticClass:"subtitle value"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }